import React from 'react';
import { Linkedin, Youtube, Instagram, Facebook, Phone, Globe } from 'lucide-react';
export function Footer() {
  return <footer className="bg-stone-950 text-stone-300 py-16" data-id="element-43" data-mp="3ggtwodvnbb34">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-44" data-mp="32oe11y52qfc8">
        <div className="grid grid-cols-2 md:grid-cols-4 lg:grid-cols-5 gap-8 mb-12" data-id="element-45" data-mp="32m1bayt2r0om">
          {/* Column 1 */}
          <div className="col-span-2 lg:col-span-1" data-id="element-46" data-mp="3uf0nxb63actt">
            <h3 className="text-white font-title font-bold text-xl mb-6" data-id="element-47" data-mp="3ufjvpz20zku4">
              Dr. Scott Conkright
            </h3>
            <div className="space-y-4 text-sm" data-id="element-48" data-mp="36ms6hozeurf">
              <a href="tel:4043157150" className="flex items-center hover:text-white transition-colors" data-id="element-49" data-mp="3lf57orxofrmx">
                <Phone className="h-4 w-4 mr-2" data-id="element-50" data-mp="3qf9qwppyz0gu" />
                (404) 315-7150
              </a>
              <a href="https://scottconkright.com/contact" className="flex items-center hover:text-white transition-colors" data-id="element-51" data-mp="2a19qzer4jatl">
                <Globe className="h-4 w-4 mr-2" data-id="element-52" data-mp="3la29euiur3v8" />
                Contact Form
              </a>
            </div>
            <div className="flex space-x-4 mt-6" data-id="element-53" data-mp="3gca674crbvbq">
              <a href="#" className="text-stone-400 hover:text-white transition-colors" data-id="element-54" data-mp="3v89fgibls1ig">
                <Linkedin className="h-5 w-5" data-id="element-55" data-mp="3q727ai5jt0b9" />
              </a>
              <a href="#" className="text-stone-400 hover:text-white transition-colors" data-id="element-56" data-mp="828oa9xiabb9">
                <Youtube className="h-5 w-5" data-id="element-57" data-mp="33nlc2qvddj4" />
              </a>
              <a href="#" className="text-stone-400 hover:text-white transition-colors" data-id="element-58" data-mp="ht3axfenzcx8">
                <Instagram className="h-5 w-5" data-id="element-59" data-mp="cuijo5he43kx" />
              </a>
              <a href="#" className="text-stone-400 hover:text-white transition-colors" data-id="element-60" data-mp="qujlbn5hbf1g">
                <Facebook className="h-5 w-5" data-id="element-61" data-mp="mtr86ithkpzw" />
              </a>
            </div>
          </div>

          {/* Column 2 */}
          <div data-id="element-62" data-mp="yu7h6qjrtnxo">
            <h4 className="text-white font-medium mb-4" data-id="element-63" data-mp="yto87zc3m9vs">About</h4>
            <ul className="space-y-3 text-sm" data-id="element-64" data-mp="yrv0shtnvlmq">
              <li data-id="element-65" data-mp="13t0xsructv22">
                <a href="#" className="hover:text-white transition-colors" data-id="element-66" data-mp="13rproldfsb7s">
                  Subscribe to my Substack
                </a>
              </li>
              <li data-id="element-67" data-mp="1clumffvoy6sl">
                <a href="#" className="hover:text-white transition-colors" data-id="element-68" data-mp="1cmdywh2ko2z8">
                  Background and Philosophy
                </a>
              </li>
              <li data-id="element-69" data-mp="1hmibhw0d0dk6">
                <a href="#" className="hover:text-white transition-colors" data-id="element-70" data-mp="1mk1uf9805eig">
                  Diversity Statement
                </a>
              </li>
              <li data-id="element-71" data-mp="1ri3lohfl0k50">
                <a href="#" className="hover:text-white transition-colors" data-id="element-72" data-mp="1rgisow8x1999">
                  Blog
                </a>
              </li>
            </ul>
          </div>

          {/* Column 3 */}
          <div data-id="element-73" data-mp="3tc2wl1oskzh6">
            <h4 className="text-white font-medium mb-4" data-id="element-74" data-mp="2af3upvql3dm9">Therapy Services</h4>
            <ul className="space-y-3 text-sm" data-id="element-75" data-mp="2ah86ezuq5gx3">
              <li data-id="element-76" data-mp="25o57ec76hf9i">
                <a href="#" className="hover:text-white transition-colors" data-id="element-77" data-mp="25nlsl4ctr6zp">
                  Individual Psychotherapy
                </a>
              </li>
              <li data-id="element-78" data-mp="1wnz1bbdt7hkd">
                <a href="#" className="hover:text-white transition-colors" data-id="element-79" data-mp="1woi7juu3khik">
                  Couples Psychotherapy
                </a>
              </li>
              <li data-id="element-80" data-mp="2tbn5sqky7blg">
                <a href="#" className="hover:text-white transition-colors" data-id="element-81" data-mp="2pcnrifdbu2hc">
                  Group Therapy
                </a>
              </li>
              <li data-id="element-82" data-mp="2kc05y97vadui">
                <a href="#" className="hover:text-white transition-colors" data-id="element-83" data-mp="2kbgn8qae7lff">
                  Online Psychotherapy
                </a>
              </li>
              <li data-id="element-84" data-mp="18yef8jmd046v">
                <a href="#" className="hover:text-white transition-colors" data-id="element-85" data-mp="18yxkp0utp040">
                  Clinical Supervision
                </a>
              </li>
            </ul>
          </div>

          {/* Column 4 */}
          <div data-id="element-86" data-mp="2ru6fxy89tllp">
            <h4 className="text-white font-medium mb-4" data-id="element-87" data-mp="2rtmw2bz28n51">
              Relationship Animals
            </h4>
            <ul className="space-y-3 text-sm" data-id="element-88" data-mp="2woanailg7vnb">
              <li data-id="element-89" data-mp="2iw43mmj376j4">
                <a href="#" className="hover:text-white transition-colors" data-id="element-90" data-mp="2iwmccimxrd7x">
                  Take the Assessment
                </a>
              </li>
              <li data-id="element-91" data-mp="3bk029ws7v8ij">
                <a href="#" className="hover:text-white transition-colors" data-id="element-92" data-mp="3bjgp0tdih8au">
                  Meet the Archetypes
                </a>
              </li>
            </ul>
          </div>

          {/* Column 5 */}
          <div data-id="element-93" data-mp="31kr8b3xcptw6">
            <h4 className="text-white font-medium mb-4" data-id="element-94" data-mp="31l13r7160t99">Forms / Resources</h4>
            <ul className="space-y-3 text-sm" data-id="element-95" data-mp="36jkkmt0wjeur">
              <li data-id="element-96" data-mp="36mgn8unp2rpj">
                <a href="#" className="hover:text-white transition-colors" data-id="element-97" data-mp="1q6njec5mevxz">
                  Release of Info
                </a>
              </li>
              <li data-id="element-98" data-mp="1v71p3njr1tsu">
                <a href="#" className="hover:text-white transition-colors" data-id="element-99" data-mp="1v3dyaw5ovlht">
                  Intake Form
                </a>
              </li>
              <li data-id="element-100" data-mp="1innyg22igwci">
                <a href="#" className="hover:text-white transition-colors" data-id="element-101" data-mp="1im34oeo0thfp">
                  Group Therapy Agreement
                </a>
              </li>
              <li data-id="element-102" data-mp="1rnstdcqiq29s">
                <a href="#" className="hover:text-white transition-colors" data-id="element-103" data-mp="1rnb08oz5k463">
                  Procedures and Patient Contract
                </a>
              </li>
              <li data-id="element-104" data-mp="13vm0wonwyffn">
                <a href="#" className="hover:text-white transition-colors" data-id="element-105" data-mp="zwmybapnmurd">
                  Clinical Supervision
                </a>
              </li>
            </ul>
          </div>
        </div>

        <div className="pt-8 border-t border-stone-800 text-sm text-stone-500 flex flex-col md:flex-row justify-between items-center" data-id="element-106" data-mp="18xbf2d6fn97y">
          <p data-id="element-107" data-mp="l65zlz4emiy6">
            &copy; {new Date().getFullYear()} Dr. Scott Conkright. All rights
            reserved.
          </p>
          <div className="mt-4 md:mt-0 space-x-4" data-id="element-108" data-mp="g6bbg3c0k7gt">
            <a href="#" className="hover:text-white transition-colors" data-id="element-109" data-mp="2gbf4pf687orl">
              Privacy Policy
            </a>
            <a href="#" className="hover:text-white transition-colors" data-id="element-110" data-mp="2l8fadoz5ypi6">
              Terms of Service
            </a>
          </div>
        </div>
      </div>
    </footer>;
}